import React from "react"

class BillingPolicyDataType extends  React.Component {
  constructor(props) {
    super(props)
    this.onViewBillingPolicy = this.onViewBillingPolicy.bind(this);
  }

  render() {
    if (this.props.row.billing_policy){
    return(
      <div>
        <a href="#" onClick={this.onViewBillingPolicy.bind(null, this.props.row.billing_policy)}>{this.props.row.billing_policy.name}</a>
      </div>

    )
    } else {
      return (
        <div>
          <span className="none">{I18n.t('none')}</span>
        </div>
      )
    }
  }

  onViewBillingPolicy(billing_policy, event) {
    event.preventDefault();

    BootstrapDialog.show({
      title: I18n.t('view_billing_policy') + ' - ' + billing_policy.name,
      onshown: function (dialog) {
        ReactDOM.render(
          <BillingPolicyBuilder {...billing_policy} hideModalButtons={true} read_only={true} />,
          document.getElementById('view-billing-policy')
        );
      },
      size: 'size-wide',
      message: '<div id="view-billing-policy"></div>',
      buttons: [
        {
          label: I18n.t('ok'),
          cssClass: 'btn btn-secondary',
          action: function (dialog) {
            dialog.close();
          }
        },
      ]
    });
  }
}

export default BillingPolicyDataType